
import { VendorExcemptionChangeData } from "../models/VendorExcemptionChangeData";
import { AxiosConfig } from "./AxiosConfig";
import { VendorBlockExcemptionViewData} from "../models/VendorBlocking/VendorBlockExcemptionViewData";

  const getVendorData = async (
    vendorNo: string,
    vendorType:string,
    successCallback: (data: VendorExcemptionChangeData) => void,
    errorCallback: (error: Error) => void
  ) => {
    try {
      const resp = await AxiosConfig.get(`/VendorBlockExcemption/GetVendorDataForBlockExcemption`,{
        params: { vendorNo: vendorNo,vendorType:vendorType },
      });
       
      successCallback(resp.data);
    } catch (err: any) {
      // Handle Error Here
      console.error(err);
      errorCallback(err);
    }
  };

  const submitVendorExcemptionRequest = async (
    vendorExcemptionSubmitData: VendorExcemptionChangeData,
      successCallback: (vendorExtendData: any) => void,
      errorCallback: (error: Error) => void
    ) => {
      try {
        const resp = await AxiosConfig.post("/VendorBlockExcemption/BlockExcemptionVendor", vendorExcemptionSubmitData);
        successCallback(resp.data);
      } catch (err: any) {
        // Handle Error Here
        console.error(err);
        errorCallback(err);
      }
    };

    const getSavedBlockDetailData = async (
        requestId: number,
        successCallback: (bockData: VendorBlockExcemptionViewData) => void,
        errorCallback: (error: Error) => void
      ) => {
        try {
          const resp = await AxiosConfig.get("/VendorBlockExcemption/GetVendorBlockDetailData?requestId=" + requestId);
          successCallback(resp.data);
        } catch (err: any) {
          // Handle Error Here
          console.error(err);
          errorCallback(err);
        }
      };

export const VendorBlockExcemptionService = {    
    getVendorData,
    submitVendorExcemptionRequest,
    getSavedBlockDetailData
  };